import client from '@api/client';
import { apiRequestUrl } from '@utils/apiOrigin';

/** {@code skipAuthRedirect}: a refusal is the caller's to handle, not a reason to sign the user out. */
export const fetchAuthBlob = async (url: string, { skipAuthRedirect = false } = {}): Promise<Blob> => {
  const res = await client.get(apiRequestUrl(url), { responseType: 'blob', ...(skipAuthRedirect && { skipAuthRedirect }) });
  return res.data as Blob;
};

/** The caller owns the returned object URL and must revoke it. */
export const fetchAuthBlobUrl = async (url: string): Promise<string> =>
  URL.createObjectURL(await fetchAuthBlob(url));
